/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const MutateContentResponse = zod.object({
  data: zod.object({
    clientIdMap: zod.array(
      zod.object({
        clientId: zod.string(),
        lineageUuid: zod.uuid().describe('UUID v4 identifier'),
        uuid: zod.uuid().describe('UUID v4 identifier'),
      }),
    ),
    idempotencyKey: zod.uuid().describe('UUID v4 identifier'),
    operationId: zod
      .uuid()
      .describe(
        'Identifies the ONE committed transaction, even where dependency planning produced several repository operations internally.',
      ),
    replayed: zod
      .boolean()
      .describe(
        'True when this response was served from a stored receipt rather than a new write. The body is otherwise identical.',
      ),
    roots: zod.array(
      zod.object({
        lineageUuid: zod.uuid().describe('UUID v4 identifier'),
        name: zod.string(),
        uuid: zod.uuid().describe('UUID v4 identifier'),
      }),
    ),
    unchanged: zod.object({
      removedEdges: zod.array(
        zod.object({
          edgeKey: zod.string().nullish(),
          fromUuid: zod.uuid().describe('UUID v4 identifier'),
          toUuid: zod.uuid().describe('UUID v4 identifier'),
        }),
      ),
      setEdges: zod.array(
        zod.object({
          edgeKey: zod.string().nullish(),
          edgeType: zod.string(),
          fromUuid: zod.uuid().describe('UUID v4 identifier'),
          toUuid: zod.uuid().describe('UUID v4 identifier'),
        }),
      ),
      versions: zod.array(zod.uuid().describe('UUID v4 identifier')),
    }),
    versionMap: zod.array(
      zod.object({
        lineageUuid: zod.uuid().describe('UUID v4 identifier'),
        newUuid: zod.uuid().describe('UUID v4 identifier'),
        oldUuid: zod.uuid().describe('UUID v4 identifier'),
      }),
    ),
  }),
});

export type MutateContentResponse = zod.input<typeof MutateContentResponse>;
export type MutateContentResponseOutput = zod.output<typeof MutateContentResponse>;
